import {IRecaptchaService} from "./IRecaptchaService";
import { load } from 'recaptcha-v3'
import {environment} from "../../../environments/environment";
import {ApiAccessService} from "../api/ApiAccessService";


export class RecaptchaService implements IRecaptchaService{

    constructor(private apiAccessService:ApiAccessService) {

    }

    GetToken(action:string): Promise<string> {
        return load(environment.recaptchaKey).then(recaptcha => {
            return recaptcha.execute(action)
        })
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/Recaptcha/RecaptchaService.ts